import { isPlatformBrowser } from '@angular/common';
import { inject, Injectable, PLATFORM_ID } from '@angular/core';

declare global {
  interface GlobalThis {
    dataLayer: {
      push(data: { [key: string]: string; event: string }): void;
    };
  }
}

@Injectable({
  providedIn: 'root',
})
export class GoogleTagService {
  protected platformId = inject(PLATFORM_ID);

  constructor() {}

  public pushEvent(event: string, data: { [key: string]: string }) {
    if (isPlatformBrowser(this.platformId)) {
      const gtag = globalThis as typeof globalThis & {
        dataLayer: Array<{ [key: string]: string }>;
      };
      gtag.dataLayer = gtag.dataLayer || [];
      gtag.dataLayer.push({ event, ...data });
    }
  }

  public trackEcommerce(event: string, ecommerce: Record<string, unknown>): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    const gtag = globalThis as typeof globalThis & {
      dataLayer: Array<Record<string, unknown>>;
    };
    gtag.dataLayer = gtag.dataLayer || [];
    gtag.dataLayer.push({ ecommerce: null });
    gtag.dataLayer.push({ event, ecommerce });
  }
}
